import { render, staticRenderFns } from "./ConversationMessageItem.vue?vue&type=template&id=2fd9fe5c&"
import script from "./ConversationMessageItem.vue?vue&type=script&lang=js&"
export * from "./ConversationMessageItem.vue?vue&type=script&lang=js&"
import style0 from "./ConversationMessageItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports